import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExcel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 4,
			fill: "#00C875"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_14609_41469)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M2.40625 4.40496V19.2798L13.3488 21.2239V2.46094L2.40625 4.40496ZM8.69465 14.9743L7.77594 12.564L6.87496 14.8478H5.62059L7.08695 11.6612L5.7266 8.53797H7.01633L7.84668 10.6954L8.83602 8.35742L10.0727 8.29422L8.52688 11.6343L10.1346 15.0825L8.69465 14.9743Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M21.1129 4.38818H13.7197V5.47455H16.5029V7.43354H13.7197V8.02264H16.5029V9.98162H13.7197V10.5708H16.5029V12.5297H13.7197V13.1188H16.5029V15.0778H13.7197V15.6792H16.5029V17.6381H13.7197V18.8953H21.113C21.3222 18.8953 21.4934 18.7189 21.4934 18.5033V4.78018C21.4934 4.56455 21.3222 4.38818 21.1129 4.38818ZM20.2118 17.6381H17.0763V15.6792H20.2118V17.6381ZM20.2118 15.0778H17.0763V13.1188H20.2118V15.0778ZM20.2118 12.5297H17.0763V10.5708H20.2118V12.5297ZM20.2118 9.98162H17.0763V8.02264H20.2118V9.98162ZM20.2118 7.43354H17.0763V5.47455H20.2118V7.43354Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_14609_41469",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(2 2)"
			})
		}) })
	]
});
export default SvgExcel;
